import { testimonials } from "../../../mocks/testimonials";

function Stars({ count }: { count: number }) {
  return (
    <div className="flex gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#E8500A] text-sm" />
      ))}
    </div>
  );
}

export default function TestimonialsSection() {
  return (
    <section className="bg-[#0B1829] py-24 lg:py-32 relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.03] pointer-events-none"
        style={{ backgroundImage: "repeating-linear-gradient(45deg, transparent, transparent 50px, rgba(255,255,255,0.5) 50px, rgba(255,255,255,0.5) 51px)" }}
      />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-14 gap-6">
          <div>
            <p className="text-[#E8500A] font-bold text-xs tracking-widest uppercase mb-3">Reviews</p>
            <h2 className="text-4xl lg:text-5xl font-black text-white" style={{ fontFamily: "'Barlow', sans-serif" }}>
              What Customers Are Saying
            </h2>
          </div>
          <div className="flex items-center gap-3 bg-white/5 border border-white/10 rounded-xl px-5 py-3 flex-shrink-0">
            <Stars count={5} />
            <span className="text-white font-bold text-sm">5-Star Rated</span>
            <span className="text-gray-500 text-sm">Across DFW</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((t) => (
            <div key={t.id} className="bg-white/5 border border-white/10 hover:bg-white/8 hover:border-white/20 rounded-2xl p-7 flex flex-col transition-all duration-300">
              <Stars count={t.rating} />
              <blockquote className="mt-4 mb-6 flex-1">
                <p className="text-gray-200 text-base leading-relaxed" style={{ fontStyle: "italic" }}>
                  &ldquo;{t.text}&rdquo;
                </p>
              </blockquote>
              <div className="flex items-center gap-3.5 pt-4 border-t border-white/10">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#E8500A]/20 flex-shrink-0">
                  <span className="text-[#E8500A] font-black text-base" style={{ fontFamily: "'Barlow', sans-serif" }}>
                    {t.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="font-bold text-white text-sm">{t.name}</p>
                  <p className="text-gray-500 text-xs">{t.location} &mdash; {t.service}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Post-testimonials CTA */}
        <div className="mt-12 bg-[#E8500A] rounded-2xl p-8 flex flex-col sm:flex-row items-center justify-between gap-5">
          <div>
            <h3 className="font-black text-white text-xl mb-1" style={{ fontFamily: "'Barlow', sans-serif" }}>
              Join Hundreds of Satisfied DFW Customers
            </h3>
            <p className="text-orange-100/80 text-sm">Schedule your service today and experience the Jerry&apos;s difference.</p>
          </div>
          <div className="flex flex-wrap gap-3 flex-shrink-0">
            <a href="tel:8178324968" className="flex items-center gap-2 bg-white text-[#E8500A] font-bold px-6 py-3 rounded-lg text-sm whitespace-nowrap hover:bg-orange-50 transition-colors">
              <i className="ri-phone-fill" /> Call Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
